import type { UpdateModerationConfigBody } from '@planuze/admin-contracts';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  getModerationConfig,
  getScannerRuntimeStatus,
  updateModerationConfig,
} from '../lib/moderation-config-api.js';

/* Hooks da config de moderação (ADR-0471). */

export function useModerationConfig() {
  return useQuery({ queryKey: ['moderation-config'], queryFn: () => getModerationConfig() });
}

export function useScannerRuntimeStatus(enabled = true) {
  return useQuery({
    queryKey: ['scanner-runtime-status'],
    queryFn: () => getScannerRuntimeStatus(),
    enabled,
  });
}

export function useUpdateModerationConfig() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (body: UpdateModerationConfigBody) => updateModerationConfig(body),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['moderation-config'] });
    },
  });
}
